import jsTimezoneDetect from 'jstimezonedetect'

document.addEventListener('turbolinks:load', () => {
  const fields = document.querySelectorAll('.js-tz-detect')
  fields.forEach(function (field) {
    field.value = jsTimezoneDetect.determine().name()
  })
})
